import { createFileRoute } from "@tanstack/react-router";
import Elementor7428Page from "@/pages/Elementor7428Page";
export const Route = createFileRoute("/services-directory")({
  component: RouteComponent,
  head() {
    return {
      meta: [
        {
          title: "Services Directory | Neuro Wellness TMS Centers of America",
        },
        {
          name: "description",
          content:
            "Explore all specialized psychiatric services, TMS protocols, ketamine infusions, psychotherapy, and patient resources at Neuro Wellness TMS Centers of America.",
        },
        {
          property: "og:title",
          content: "Services Directory | Neuro Wellness TMS Centers of America",
        },
        {
          property: "og:description",
          content:
            "Explore all specialized psychiatric services, TMS protocols, ketamine infusions, psychotherapy, and patient resources at Neuro Wellness TMS Centers of America.",
        },
        {
          property: "og:url",
          content: "https://neurowellnesstms.com/services-directory",
        },
        {
          property: "og:type",
          content: "website",
        },
        {
          name: "twitter:card",
          content: "summary_large_image",
        },
      ],
      links: [
        {
          rel: "canonical",
          href: "https://neurowellnesstms.com/services-directory",
        },
      ],
    };
  },
});
function RouteComponent() {
  return <Elementor7428Page />;
}
